// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_d2-0";
export var actionModalContentContainer = "_d2-1";
export var createTagButton = "_d2-2";
export var footerContainer = "_d2-7";
export var fullWidthDivider = "_d2-3";
export var hasCreateTagButton = "_d2-4";
export var noCreateTagButton = "_d2-5";
export var tagsContainer = "_d2-6";
export var tagsModalContentContainer = "_d2-8";